import { useEffect, useState } from "react";
import { ConnectedPayroll } from "../../../Component/Model/Dto/Payroll/Payroll";
import { ConnectedPayrollTableMapper } from "./ConnectedPayrollTableColumns";
import { Button, Typography } from "@mui/material";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { PayrollModal } from "./PayrollModal";
import { PayrollService } from "../../../Component/Api/Payroll/PayrollService";
import { IDropDownOptions } from "../../../Component/Common/Components/FormValidationInputs/AppSelectList";
import { useRecoilValue } from "recoil";
import { OrganisationAtom } from "../../../State/Organisation.Atom";

export const PayrollConnections = () => {
    const [payrollData, setPayrollData] = useState<ConnectedPayroll[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [openCreatePayroll, setOpenCreatePayroll] = useState<boolean>(false);
    const [authenticationTypesItems, setAuthenticationTypesItems] = useState<IDropDownOptions[]>([]);
    const [payrollTypesItems, setPayrollTypesItems] = useState<IDropDownOptions[]>([]);
    const [selectedPayrollId, setSelectedPayrollId] = useState<string>("");
    const organisation = useRecoilValue(OrganisationAtom);

    useEffect(() => {
        fetchAllData();
    }, [organisation]);

    const fetchAllData = async () => {
        if (organisation.OrganisationId < 0) return;
        setIsLoading(true);
        try {
            const [payrollsResult, payrollTypesResult, authTypesResult] = await Promise.all([
                PayrollService.getAllConnectedPayrolls(organisation.OrganisationId),
                PayrollService.getPayrollTypes(),
                PayrollService.getSage300AuthTypes()
            ]);

            setPayrollData(payrollsResult.data);

            const payrollTypesData = payrollTypesResult.data;
            if (payrollTypesData.length > 0) {
                const payrollTypesDropDown = payrollTypesData.map((data: any) => ({
                    id: data.humanResourcesTypeId,
                    value: data.humanResourcesName
                }));
                setPayrollTypesItems(payrollTypesDropDown);
            }

            const authTypesData = authTypesResult.data;
            if (authTypesData.length > 0) {
                const authTypesDropDown = authTypesData.map((data: any) => ({
                    id: data.authTypeId,
                    value: data.authTypeDescription
                }));
                setAuthenticationTypesItems(authTypesDropDown);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleView = (id: string) => {
        setSelectedPayrollId(id);
        setOpenCreatePayroll(true);
    };

    const openCreateModal = () => {
        setOpenCreatePayroll(true);
    };

    const closeCreateModal = () => {
        setSelectedPayrollId("");
        setOpenCreatePayroll(false);
        fetchAllData();
    };

    const payrollTableData = ConnectedPayrollTableMapper(payrollData, handleView, payrollTypesItems, authenticationTypesItems);

    return (
        <>
            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                Connect Payrolls
            </Typography>
            <Typography variant="body2" style={{ paddingBottom: "20px" }}>
                Set up connection details for each payroll associated with you your organisation.
            </Typography>
            <Button variant='contained' onClick={() => openCreateModal()}>Connect Payroll</Button>
            {openCreatePayroll &&
                <PayrollModal open={openCreatePayroll} closeModal={closeCreateModal} payrollTypesItems={payrollTypesItems} authenticationTypesItems={authenticationTypesItems} payrollId={selectedPayrollId} />}
            <DataTable
                table={payrollTableData}
                isLoading={isLoading}
                showEntriesPerPage={false}
                showTotalEntries={false}
                showBottomMargin={false}
            />
        </>
    );
}